import React from "react";
import { useHistory } from "react-router-dom";
import { FiLock } from "react-icons/fi";

import {
  Container,
  IconCircle,
  Title,
  Message,
  Actions,
  PrimaryButton,
  SecondaryButton,
} from "./styles";

interface IProps {
  message?: string;
}

export default function AccessDenied({
  message = "Você não tem permissão para acessar esta página.",
}: IProps) {
  const history = useHistory();

  return (
    <Container role="alert">
      <IconCircle aria-hidden>
        <FiLock />
      </IconCircle>
      <Title>Acesso negado</Title>
      <Message>{message}</Message>
      <Actions>
        <PrimaryButton type="button" onClick={() => history.push("/")}>
          Voltar para a página inicial
        </PrimaryButton>
        <SecondaryButton type="button" onClick={() => history.goBack()}>
          Voltar
        </SecondaryButton>
      </Actions>
    </Container>
  );
}
